import type { UseQueryResult } from '@tanstack/react-query';

import type { DropTimelineItem, DropTimelineResponse } from '@/hooks';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/layout/Tabs';
import { getApiErrorMessage } from '@/lib/utils';

import { TimelineRawPanel } from '../timeline-raw-panel';
import { TimelineStoryPanel } from '../timeline-story-panel';

export function DropTimelineModalTabs(props: {
  storyQ: UseQueryResult<DropTimelineResponse, Error>;
  fullQ: UseQueryResult<DropTimelineResponse, Error>;
  windowStory: string;
  windowFull: string;
  fullLimit: number;
  onSelectItem?: (item: DropTimelineItem) => void;
}) {
  const { storyQ, fullQ, windowStory, windowFull, fullLimit, onSelectItem } = props;
  return (
    <Tabs defaultValue="story" className="w-full">
      <TabsList className="w-full grid grid-cols-2">
        <TabsTrigger value="story">Story</TabsTrigger>
        <TabsTrigger value="all">All activity</TabsTrigger>
      </TabsList>
      <TabsContent value="story" className="mt-3">
        {storyQ.isFetching ? (
          <p className="text-sm text-muted-foreground">Loading story…</p>
        ) : null}
        {storyQ.isError ? (
          <p className="text-sm text-destructive">
            {getApiErrorMessage(storyQ.error, 'Failed to load story')}
          </p>
        ) : null}
        {storyQ.data ? (
          <TimelineStoryPanel
            items={storyQ.data.data.items}
            windowLabel={windowStory}
            onSelectItem={onSelectItem}
          />
        ) : null}
      </TabsContent>
      <TabsContent value="all" className="mt-3">
        {fullQ.isFetching ? (
          <p className="text-sm text-muted-foreground">Loading activity…</p>
        ) : null}
        {fullQ.isError ? (
          <p className="text-sm text-destructive">
            {getApiErrorMessage(fullQ.error, 'Failed to load activity')}
          </p>
        ) : null}
        {fullQ.data ? (
          <TimelineRawPanel
            items={fullQ.data.data.items}
            siemLimit={fullLimit}
            windowLabel={windowFull}
            onSelectItem={onSelectItem}
          />
        ) : null}
      </TabsContent>
    </Tabs>
  );
}
